// extracted by mini-css-extract-plugin
export default {"controls":"controls_controls__vzlEc","zoomControls":"controls_zoomControls__vX0Bh","horizontalSeparator":"controls_horizontalSeparator__s1eA7"};